module.exports = __webpack_public_path__ + "1_0_60/img/pass_hide.0dc2b29f.svg";